import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 17 17"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#899094",
      d: "M6.5 0a6.5 6.5 0 0 1 5.25 10.33l4.5 4.5a1 1 0 0 1-1.42 1.41l-4.5-4.5A6.5 6.5 0 1 1 6.5 0m0 2a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9"
    }, null, -1)
  ]))]))
}
export default { render: render }